import React, { Fragment } from 'react';
import DaywiseConsolidatedView from './DaywiseConsolidatedView';

// Thin route entry — the V3 shell lives inside the view.
const DaywiseConsolidated = () => (
    <Fragment>
        <DaywiseConsolidatedView />
    </Fragment>
);

export default DaywiseConsolidated;
